import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 10분 동안은 신선(stale 아님) 처리, 1시간 캐시 유지
      staleTime: 1000 * 60 * 10,
      // v5: cacheTime -> gcTime (garbage-collection time)
      gcTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    },
  },
});